const AdminRouter = [

    {
        path: "/admin-login",
        name: "login",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/Admin/AdminLogin.vue")
    },


    {
        path: "/Admin",
        name: "adminMain",
        component: () => import("@/Views/Admin/AdminMain.vue"),
        children: [
            {
                path: "admin-dashbord",
                name: "dashbord",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/Admin/DashbordPage.vue")
            },
            {
                path: "adminandUserMessage",
                name: "AdminUserMessageNormalUser",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/Admin/AdminUserMessageNormalUser.vue")
            },
            {
                path: "admin-users-noti",
                name: "adminUsersnoti",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/Admin/AdminUserNoti.vue")
            },
            {
                path: "realusers",
                name: "realusers",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/Admin/NewUser.vue")
            }, {
                path: "user-transID",
                name: "TranscationID",
                meta: {
                    requireAuth: false
                },
                component: () => import("@/Views/Admin/TransactionID.vue")
            }
        ]
    }
]

export default AdminRouter;